import { InputEvents, Obj, UnresolvedObj, Metrics, ObjectState, Surface } from "../types";
import { makeSpriteZeroesInvisible } from "../core";
import { fontDict } from "../fontDict";

type CreateCursorObjectArgs = Pick<UnresolvedObj, "id">;

// const sprite = makeSpriteZeroesInvisible(fontDict["Cursor::Arrow"]);
const sprite = fontDict["Cursor::Arrow"];

export const createCursorObject = (args: CreateCursorObjectArgs): Obj => {
  return {
    ...args,
    x: 0,
    y: 0,
    z: Infinity,
    sprite,
    w: sprite.w,
    h: sprite.h,
    step: (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => {
      obj.x = inputEvents.mouseX;
      obj.y = inputEvents.mouseY;
    }
  };
}
